import { Injectable } from '@angular/core';
import { getConfiguration } from '@lx/shared/tokens';
import { Company, CompanyEnum } from '../models/company.model';
import { isSupportedLanguage } from '../functions';

@Injectable({
  providedIn: 'root',
})
export class ApplicationFormService {
  private readonly APPLICATION_FORM_NAME = 'Application Form';
  private readonly ADULT_APPLICATION_FORM_NAME = 'Adult Application Form';
  private readonly SUMMER_CAMP_APPLICATION_FORM_NAME = 'Summer Camp Application Form';

  private readonly ALPADIA_ADULT_APPLICATION_FORM_URL =
    'https://www.alpadia.com/assets/data/agentzone/Enrolment Forms/Language courses/ADU_Application_form_EN.pdf';
  private readonly ALPADIA_SUMMER_CAMP_APPLICATION_FORM_URL =
    'https://www.alpadia.com/assets/data/agentzone/Enrolment Forms/Language Camps/JUN-Application_form_EN.pdf';
  private readonly KAPLAN_ADULT_APPLICATION_FORM_URL = 'https://ebook.kaplaninternational.com/pricelist/2024-pricelist/kaplan-application-form.pdf';
  private readonly ACADEMIC_YEAR_ABROAD_ENGLISH_FORM_URL = 'https://kaplaninternational.tfaforms.net/255682';
  private readonly ACADEMIC_YEAR_ABROAD_GERMAN_FORM_URL = 'https://kaplaninternational.tfaforms.net/255753';
  private readonly ACADEMIC_YEAR_ABROAD_FRENCH_FORM_URL = 'https://kaplaninternational.tfaforms.net/255752';
  private readonly YOUNG_ADULTS_KIL_FORM_URL = 'https://kaplaninternational.tfaforms.net/255705';
  private readonly YOUNG_ADULTS_ALP_FORM_URL = 'https://kaplaninternational.tfaforms.net/255774';

  private readonly ayaUrlMap = {
    english: this.ACADEMIC_YEAR_ABROAD_ENGLISH_FORM_URL,
    german: this.ACADEMIC_YEAR_ABROAD_GERMAN_FORM_URL,
    french: this.ACADEMIC_YEAR_ABROAD_FRENCH_FORM_URL,
  };

  private readonly configuration = getConfiguration();

  getApplicationForms(company: Company) {
    switch (company) {
      case CompanyEnum.ALP: {
        if (this.configuration.PRICE_LIST_SHOW_JUNIOR_CAMPS) {
          return [
            {
              name: this.APPLICATION_FORM_NAME,
              url: this.ALPADIA_ADULT_APPLICATION_FORM_URL,
            },
          ];
        }
        return [
          {
            name: this.ADULT_APPLICATION_FORM_NAME,
            url: this.ALPADIA_ADULT_APPLICATION_FORM_URL,
          },
          {
            name: this.SUMMER_CAMP_APPLICATION_FORM_NAME,
            url: this.ALPADIA_SUMMER_CAMP_APPLICATION_FORM_URL,
          },
        ];
      }
      case CompanyEnum.KIL:
        return [
          {
            name: this.APPLICATION_FORM_NAME,
            url: this.KAPLAN_ADULT_APPLICATION_FORM_URL,
          },
        ];
      default:
        return [];
    }
  }

  getAyaApplicationForm(language: string) {
    const supportedLanguage = language?.toLowerCase();
    if (!isSupportedLanguage(supportedLanguage)) {
      return [];
    }

    return [
      {
        name: this.APPLICATION_FORM_NAME,
        url: this.ayaUrlMap[supportedLanguage],
      },
    ];
  }

  getYoungAdultsApplicationForm() {
    return [
      {
        name: this.APPLICATION_FORM_NAME,
        url: this.YOUNG_ADULTS_KIL_FORM_URL,
        company: CompanyEnum.KIL,
      },
      {
        name: this.APPLICATION_FORM_NAME,
        url: this.YOUNG_ADULTS_ALP_FORM_URL,
        company: CompanyEnum.ALP,
      },
    ];
  }

  getSummerCampApplicationForm(company: Company) {
    if (company === CompanyEnum.ALP) {
      return {
        name: this.APPLICATION_FORM_NAME,
        url: this.ALPADIA_SUMMER_CAMP_APPLICATION_FORM_URL,
      };
    }
    return null;
  }
}
